import { Inject, Pipe, PipeTransform } from '@angular/core';
import * as coreTypes from '../../core/types';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Pipe({
  name: 'authResource',
})
export class AuthResourcePipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    @Inject(coreTypes.SERVICE_TOKEN) private configService: coreTypes.IConfigService
  ) {}

  async transform(src: string, blob = false): Promise<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.configService.get('AuthorizationToken')}`,
    });
    try {
      const resourceBlob = await this.http.get(src, { headers, responseType: 'blob' }).toPromise();

      if (!blob) {
        const reader = new FileReader();
        // @ts-ignore
        return new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result as string);
          reader.readAsDataURL(resourceBlob);
        });
      } else {
        return new Promise((resolve) => {
          resolve(resourceBlob);
        });
      }
    } catch {
      return '';
    }
  }
}
